import React from "react";
import { SolutionSection } from "@/components/design-system/SolutionSection/SolutionSection";

const leftItems = [
  "Static portals users visit once and rarely return to",
  "Generic content sent to all members or employees alike",
  "No institutional insight from passive browsing behavior",
  "No advisor signals — warm leads go cold",
] as const;

const rightItems = [
  "Memory-enabled conversations that get smarter with every session",
  "Personalized guidance tailored to each individual's situation and goals",
  "Real-time insight into needs, goals, and hidden opportunities",
  "Context-rich handoffs to advisors at exactly the right moment",
] as const;

export const BravoDifferenceSection: React.FC = () => (
  <SolutionSection
    label="The Bravo Difference"
    backgroundSrc="/home-solutions-background.jpg"
    heading={
      <>
        From static content to{" "}
        <span className="text-primary-500">intelligent activation.</span>
      </>
    }
    description="Most financial guidance today lives in static portals, articles and resources that inform but rarely engage. Bravo's AI-driven guidance helps users navigate real decisions while surfacing the signals institutions need to grow."
    leftTitle="Today's reality"
    rightTitle="Bravo's shift"
    leftItems={leftItems}
    rightItems={rightItems}
  />
);
